import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { IBusinessFunction } from "../interfaces/ibusinessfunction";
import { BusinessFunctionService } from "../services/businessfunction.service";
import { Observable } from "rxjs";

@Injectable()
export class BusinessFunctionsResolver implements Resolve<IBusinessFunction[]> {

    constructor(private businessFunctionService: BusinessFunctionService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<IBusinessFunction[]> {
        return this.businessFunctionService.getAll();
    }
}
